<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <div class="ma-5"></div>
        <v-row>
            <v-col cols="12" v-for="(item, idx) in listCamera" :key="idx">
                <v-card elevation="24" class="mb-0">
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ item.camera_name }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <div class="white--text text-end pa-1">
                            <v-btn small :to="{ name: 'Playback', params: { camera_id: item.camera_id } }" color="success">
                                <v-icon>mdi-youtube-tv</v-icon>
                                <h5>タイムラプス</h5>
                            </v-btn>
                        </div>
                    </v-toolbar>
                    <v-card-text class="pa-0">
                        <v-responsive :aspect-ratio="16 / 9">
                            <img :src="item.jpgImg" width="100%" style="aspect-ratio: 16 / 9; object-fit: contain; background-color: lightgray" />

                            <!--
                            <v-img :src="item.jpgImg" :aspect-ratio="16 / 9" style="aspect-ratio: 16 / 9" width="100%">
                                <div class="white--text text-end pa-1">
                                    <v-btn small :to="{ name: 'Playback', params: { camera_id: item.camera_id } }" color="success">
                                        <v-icon>mdi-youtube-tv</v-icon>
                                        <h4>タイムラプス</h4>
                                    </v-btn>
                                </div>
                            </v-img>
                            -->
                        </v-responsive>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-show="loadingMax > loadingCount">
                <v-btn block @click="buildCameraList()" color="success">さらに表示</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "LastImages",
    //========================================================
    data() {
        return {
            jwt: "",
            myInfo: [],
            keywordFilter: "",
            dbSites: [],
            dbCameras: [],
            listCamera: [
                //{ jpgImg: "", date: "", camera_id: "", camera_name: "", site_name: "", site_pref: ""}
            ],
            bufferImages: [],
            filter: null,
            loadingCount: 0,
            loadingMax: 0,
            noImage: require("@/assets/no-image.jpg"),
            isLoading: false,
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.isLoading = true;
        await this.getCameras();
        await this.buildCameraList();
        await new Promise((r) => setTimeout(r, 1000));
        this.isLoading = false;
        window.scrollTo(0, 0);
        this.putUserOperated();
    },
    //========================================================
    watch: {},
    //========================================================
    methods: {
        //====================================================
        async getCameras() {
            await this.axios({
                method: "GET",
                url: "/web/api/cameras",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(async (response) => {
                this.dbCameras = response.data.json;
                this.loadingMax = this.dbCameras.length;
            });
        },
        //====================================================
        async buildCameraList() {
            let startCount = this.loadingCount;
            let endCount = this.loadingCount + 8;
            this.loadingCount = this.loadingCount + 8;
            for (let idx in this.dbCameras) {
                if (startCount <= idx && idx < endCount) {
                    let camera_id = this.dbCameras[idx].id;
                    let camera_name = this.dbCameras[idx].name;
                    this.listCamera.push({
                        camera_id: camera_id,
                        jpgImg: "", //window.URL.createObjectURL(response.data),
                        date: "---", //response.headers["x-image-date"],
                        camera_name: camera_name,
                        device: JSON.parse(JSON.stringify(this.dbCameras[idx])),
                    });
                }
            }
            for (let idx in this.listCamera) {
                if (startCount <= idx && idx < endCount) {
                    let camera_id = this.listCamera[idx].camera_id;
                    this.getLastImage(camera_id, this.listCamera[idx]);
                }
            }
        },
        //====================================================
        getLastImage(camera_id, imgObj) {
            //------------------
            // if (camera_id > -99999999) {
            //     imgObj.jpgImg = this.noImage;
            //     imgObj.data = this.$moment().format("YYYY-MM-DD HH:mm:ss");
            //     return false;
            // }
            //------------------
            this.axios({
                responseType: "blob",
                method: "GET",
                url: "/web/api/last-image/" + camera_id + "/",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            })
                .then((response) => {
                    imgObj.jpgImg = window.URL.createObjectURL(response.data);
                    imgObj.date = response.headers["x-image-date"];
                    //this.listCamera = Object.assign([], this.listCamera);
                })
                .catch((err) => {
                    const { status, statusText } = err.response;
                    alert(status + " : " + statusText);
                });
        },
        //====================================================
        putUserOperated() {
            this.axios({
                method: "PUT",
                url: "/web/api/user_operated",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            });
        },
        //====================================================
    },
    //========================================================
};
</script>
